import { render } from "./EmojiFeedback.vue?vue&type=template&id=495f4223"
import script from "./EmojiFeedback.vue?vue&type=script&lang=js"
export * from "./EmojiFeedback.vue?vue&type=script&lang=js"

import "./EmojiFeedback.vue?vue&type=style&index=0&id=495f4223&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__